import React, { Component } from "react";

class DataLoadingSpinner extends Component {
    constructor(params) {
        super(params);
    }

    render() {
        if (window.document.documentMode) { //do this because the other loading animation doesn't work properly in IE
            return (
                <div className="gif-spinner">
                    <img src="../../../images/loading_symbol_3.gif" />
                </div>
            );
        }
        else {
            return (
                <div className="spinner">
                    <div className="bounce1" />
                    <div className="bounce2" />
                    <div className="bounce3" />
                </div>
            );
        }
    }
}

export default DataLoadingSpinner;